import InfoIcon from "../../../components/Atomos/Icons/InfoIcon";

type NetworkingMapInfoTooltipProps = {
  text: string;
  iconClassName?: string;
  iconSizePx?: number;
};

export default function NetworkingMapInfoTooltip({
  text,
  iconClassName = "text-gray-font",
  iconSizePx = 14,
}: NetworkingMapInfoTooltipProps) {
  return (
    <div className="relative group inline-flex items-center justify-center">
      <span
        className={`inline-flex cursor-help items-center justify-center ${iconClassName}`}
        aria-label={text}
        role="img"
      >
        <InfoIcon
          className="fill-current"
          width={iconSizePx}
          height={iconSizePx}
        />
      </span>

      <div className="pointer-events-none absolute left-0 top-full z-50 mt-1.5 hidden min-w-[200px] max-w-[240px] group-hover:block">
        <div className="rounded bg-gray-font px-2.5 py-2 text-left text-xs font-normal leading-snug text-neutral">
          {text}
        </div>
      </div>
    </div>
  );
}
